/**
 * Semantic linter rule for Timer: `Timer::get_configuration_warnings()`
 * (timer.cpp:200-208) warns when `wait_time < 0.05 - CMP_EPSILON`.
 */
import { scalarSlotValue } from '../../../godot/variant/variantBool.js';
import { ruleRegistry } from '../../../linter/RuleRegistry.js';
import { CMP_EPSILON } from '../../../godot/math/math.js';
import { armDiagnostic, armEmits, groundedArm } from '../../../linter/ruleArms.js';
const arms = {
    lowWaitTime: groundedArm('timer-low-wait-time', { kind: 'configuration-warning' }),
};
const LOW_WAIT_TIME_THRESHOLD = 0.05 - CMP_EPSILON;
function checkTimerWaitTime(context) {
    const { node } = context;
    const raw = node.rawProperties.wait_time;
    if (raw === undefined)
        return [];
    const waitTime = scalarSlotValue(raw);
    if (waitTime === null || !Number.isFinite(waitTime))
        return [];
    // Godot's guard has no lower bound, but the setter refuses `<= 0` (timer.cpp:93),
    // an error from v.positiveFloat. The `> 0` clause is this repo's, not timer.cpp's:
    // it keeps one defect from being reported at two severities.
    if (waitTime <= 0 || waitTime >= LOW_WAIT_TIME_THRESHOLD)
        return [];
    return [
        armDiagnostic(arms.lowWaitTime, node, `Timer '${node.name}' has 'wait_time = ${raw}', below 0.05 seconds. Very low timer wait times behave differently across frame rates; consider a script's process loop instead.`),
    ];
}
const timerWaitTimeRule = {
    meta: {
        name: 'valid-timer-wait-time',
        description: 'Flags a Timer with a very low positive wait_time (< 0.05s), which behaves differently across frame rates',
        category: 'validation',
        applicableNodeTypes: ['Timer'],
        emits: armEmits(arms),
    },
    check: checkTimerWaitTime,
};
ruleRegistry.register(timerWaitTimeRule);
//# sourceMappingURL=linter.js.map